import { render, staticRenderFns } from "./literatureDetails.vue?vue&type=template&id=3e4773ec&scoped=true&"
import script from "./literatureDetails.vue?vue&type=script&lang=js&"
export * from "./literatureDetails.vue?vue&type=script&lang=js&"
import style0 from "./literatureDetails.vue?vue&type=style&index=0&id=3e4773ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4773ec",
  null
  
)

export default component.exports